export default __webpack_public_path__ + "static/media/step_H@2x.d9150967.png";